// extracted by mini-css-extract-plugin
export default {"button":"tvOyeXQKs3ABfHTIGqfNPQ==","iconButton":"UybrWKYEBEj-SzcRqlVtYQ=="};